module.exports = __webpack_public_path__ + "img/x-circle@2x.965d6f9e.png";